"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'ArticleText_1_0_0',
  enableArticleDate: '',
  enableReadTime: '',
  showCategoryTag: '',
  articleAuthor: '',
  articleInformation: {},
  date: '',
  theme: 'dark'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;